var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationObserver',{ref:"observer",scopedSlots:_vm._u([{key:"default",fn:function(ref){
var handleSubmit = ref.handleSubmit;
var invalid = ref.invalid;
var reset = ref.reset;
return [_c('artisio-modal',{ref:"biddersModal",attrs:{"size":"md","visible":_vm.modal.show,"hide-footer":true,"body-class":'',"title":_vm.computedTitle,"show-confirmation":false,"scrollable":""},on:{"hidden":_vm.onHidden}},[_c('customer-info-table',{attrs:{"customer":_vm.object}})],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }